<template>
  <div class="box">
    <div class="top">
      <span>模板名称：{{ templateInfo.templateName }}</span>
      <span>性别：{{ userform.sex === 0 ? "男" : "女" }}</span>
      <span v-if="userform.disciplineType === 1">科别：理科</span>
      <span v-if="userform.disciplineType === 2">科别：文科</span>
      <span v-if="userform.disciplineType === 0 ||
        userform.disciplineType === 3 ||
        userform.disciplineType === 4
        ">科目：<span v-if="userform.discipline.indexOf('物理') !== -1">物理 </span><span
          v-if="userform.discipline.indexOf('历史') !== -1">历史 </span>
        <span v-if="userform.discipline.indexOf('化学') !== -1">化学 </span><span
            v-if="userform.discipline.indexOf('生物') !== -1">生物 </span>
        <span v-if="userform.discipline.indexOf('政治') !== -1">政治 </span><span
            v-if="userform.discipline.indexOf('地理') !== -1">地理 </span></span>
      <span>毕业年份：{{ userform.graduateYear }}</span>
      <span>高考成绩：{{ userform.adminScore ? userform.adminScore : 0 }}</span>
      <span>等位分：{{ examscore }}</span>
      <span>位次：{{
          userform.scores
              ? userform.scores.accumulate
                  ? userform.scores.accumulate
                  : 0
              : 0
        }}</span>
    </div>
    <div class="button">
      <div v-if="batch">
        <el-button type="primary" size="small">{{ batch }}</el-button>
      </div>
    </div>

    <volunteerViewTable ref="volunteerTable" @addOptionsMarjor="addOptionsMarjor"
                    @addMajorVolunteerClick="addMajorVolunteerClick" @addVolunteerClick="addVolunteerClick"
                    @addVolunteerOptionsClick="addVolunteerOptionsClick" @preview="preview" @getOptions="getOptions"
                    @editOptionsMarjor="editOptionsMarjor" @exportTemplate="exportTemplate" @func="showzyzy"
                    @editOptions="editOptions"
                    @collegeList="collegeList" @showaddmajor="showaddmajor" @specialtyListSort="specialtyListSort"
                    @delspecialtyList="delspecialtyList" @getDraftList="getDraftList" :idOne="idOne" :voPa="voPa"
                    :id="draftId"
                    :year="year" :admissionYear="admissionYear"
                    :templateInfo="currentBatch.collegeList ? JSON.parse(JSON.stringify(currentBatch.collegeList)) : null"
                    :activeName="activeName"/>

    <!-- 添加院校 -->
    <el-dialog :title="'添加院校 ' + formInline.admitBatch" :visible.sync="dialogTableVisible1" width="90%"
               :close-on-click-modal="false" :close-on-press-escape="false" @closed="closedschool">
      <div class="top">
        <span>学生姓名：{{ userform.realName }}</span>
        <span>联系电话：{{ userform.contactPhone }}</span>
        <span>性别：{{ userform.sex === 0 ? "男" : "女" }}</span>
        <span v-if="userform.disciplineType === 1">科别：理科</span>
        <span v-if="userform.disciplineType === 2">科别：文科</span>
        <span v-if="userform.disciplineType === 0 ||
          userform.disciplineType === 3 ||
          userform.disciplineType === 4
          ">科目：<span v-if="userform.discipline.indexOf('物理') !== -1">物理 </span><span
            v-if="userform.discipline.indexOf('历史') !== -1">历史 </span>
          <span v-if="userform.discipline.indexOf('化学') !== -1">化学 </span><span
              v-if="userform.discipline.indexOf('生物') !== -1">生物 </span>
          <span v-if="userform.discipline.indexOf('政治') !== -1">政治 </span><span
              v-if="userform.discipline.indexOf('地理') !== -1">地理 </span></span>
        <span>所在中学：{{ userform.schoolName }}</span>
        <span>毕业年份：{{ userform.graduateYear }}</span>
        <span>高考成绩：{{ userform.adminScore ? userform.adminScore : 0 }}</span>
        <span>等位分：{{ examscore }}</span>
        <span>位次：{{
            userform.scores
                ? userform.scores.accumulate
                    ? userform.scores.accumulate
                    : 0
                : 0
          }}</span>
      </div>
      <div class="el-dialog-div">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <!-- <el-form-item>
            <el-button size="small" type="info" disabled>{{
              userform.examProvince
            }}</el-button>
          </el-form-item> -->
          <!-- <el-form-item label="科别:">
            <el-select
              v-model="formInline.disciplineType"
              placeholder=""
              size="small"
              disabled
              style="width: 100px; margin-right: 10px"
            >
              <el-option
                v-for="item in disciplineTypeoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批次:">
            <el-select
              v-model="formInline.admitBatch"
              disabled
              placeholder="不限"
              size="small"
              style="width: 140px; margin-right: 10px"
            >
            </el-select>
          </el-form-item> -->
          <el-form-item label="院校省份:">
            <el-select v-model="formInline.collegeProvinceId" placeholder="不限" size="small" clearable
                       style="width: 100px; margin-right: 10px">
              <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="院校名称:">
            <el-input v-model="formInline.keyWord" placeholder="请输入院校名称或代码" size="small" style="width: 180px">
            </el-input>
          </el-form-item>
          <el-form-item label="院校特性:">
            <el-select v-model="collegeCharacter" placeholder="不限" multiple @change="changecollegeCharacter"
                       size="small"
                       style="width: 220px; margin-right: 10px">
              <el-option v-for="item in optionsCharacter" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分段:">
            <el-input v-model="formInline.scoreMin" placeholder="最低分" size="small" style="width: 70px"></el-input>
            -
            <el-input v-model="formInline.scoreMax" placeholder="最高分" size="small"
                      style="width: 70px; margin-right: 10px"></el-input>
          </el-form-item>
          <el-form-item label="位次:">
            <el-input v-model="formInline.accumulateMin" placeholder="最低位" size="small"
                      style="width: 70px"></el-input>
            -
            <el-input v-model="formInline.accumulateMax" placeholder="最高位" size="small"
                      style="width: 70px; margin-right: 10px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="pageuniversity">搜索</el-button>
            <el-button size="small" type="primary" @click="sureschool">确定</el-button>
          </el-form-item>
        </el-form>
        <el-table :stripe="true" ref="myTable" size="mini" :data="gridData1" max-height="460px" border
                  :row-key="getRowKeys" @select-all="selectAllCollege" @select="handleSelectionChangeschool"
                  @row-click="handleRowSelectionChangeschool"
                  :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                  :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
          <el-table-column type="selection" :reserve-selection="true" width="80"></el-table-column>
          <el-table-column prop="collegeCode" label="院校代码" min-width="80"></el-table-column>
          <el-table-column prop="collegeName" label="院校名称" min-width="100" :show-overflow-tooltip="true">
          </el-table-column>
          <!-- <el-table-column prop="specialtyNames" label="专业组代码" width="100" v-if="voPa === 3"></el-table-column>
          <el-table-column prop="specialtyOptions" :show-overflow-tooltip="true" label="专业组名称" min-width="150" v-if="voPa === 3"></el-table-column> -->
          <el-table-column prop="collegeCity" label="所在城市" width="80"
                           :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="院校特性" width="220">
            <template slot-scope="scope">
              <span v-if="scope.row.collegeCharacter &&
                scope.row.collegeCharacter.includes('2')
                ">985 </span>
              <span v-if="scope.row.collegeCharacter &&
                scope.row.collegeCharacter.includes('1')
                ">211 </span>
              <span v-if="scope.row.collegeCharacter &&
                scope.row.collegeCharacter.includes('3')
                ">双一流</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="admitBatch" label="录取批次" min-width="100" :show-overflow-tooltip="true"></el-table-column> -->
          <!-- <el-table-column
            label="高考成绩"
            width="65"
          >
          <template>
              {{examscore ? examscore : 0}}
            </template></el-table-column> -->
          <el-table-column prop="scoreYearThis" :label="admissionYear + '最低分'" width="65"></el-table-column>
          <!-- <el-table-column
            prop="scoreYearLast"
            :label="year - 2 + '最低分'"
            width="65"
          ></el-table-column> -->
          <el-table-column prop="accumulateYearThis" :label="admissionYear + '最低位次'" width="68"></el-table-column>
          <el-table-column prop="accumulateYearLast" :label="admissionYear - 1 + '最低位次'"
                           width="68"></el-table-column>
          <el-table-column prop="accumulateYearOther" :label="admissionYear - 2 + '最低位次'"
                           width="68"></el-table-column>
          <el-table-column prop="planYearLast" :label="planYear - 1 + '计划数'" width="65"></el-table-column>
          <el-table-column prop="planYearThis" :label="planYear + '计划数'" width="65"></el-table-column>
          <el-table-column prop="planDiff" label="计划增减" width="68"></el-table-column>
        </el-table>
        <el-pagination background @current-change="handleChange" :current-page.sync="formInline.current"
                       layout="prev, pager, next" :total="total" :page-size="500">
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 添加专业组志愿 -->
    <el-dialog :title="'添加专业组' + formInlinezyz.admitBatch" :visible.sync="dialogTableVisiblezyz" width="90%"
               :close-on-click-modal="false" :close-on-press-escape="false" @closed="closedoptions">
      <div class="top">
        <span>学生姓名：{{ userform.realName }}</span>
        <span>联系电话：{{ userform.contactPhone }}</span>
        <span>性别：{{ userform.sex === 0 ? "男" : "女" }}</span>
        <span v-if="userform.disciplineType === 1">科别：理科</span>
        <span v-if="userform.disciplineType === 2">科别：文科</span>
        <span v-if="userform.disciplineType === 0 ||
          userform.disciplineType === 3 ||
          userform.disciplineType === 4
          ">科目：<span v-if="userform.discipline.indexOf('物理') !== -1">物理 </span><span
            v-if="userform.discipline.indexOf('历史') !== -1">历史 </span>
          <span v-if="userform.discipline.indexOf('化学') !== -1">化学 </span><span
              v-if="userform.discipline.indexOf('生物') !== -1">生物 </span>
          <span v-if="userform.discipline.indexOf('政治') !== -1">政治 </span><span
              v-if="userform.discipline.indexOf('地理') !== -1">地理 </span></span>
        <span>所在中学：{{ userform.schoolName }}</span>
        <span>毕业年份：{{ userform.graduateYear }}</span>
        <span>高考成绩：{{ userform.adminScore ? userform.adminScore : 0 }}</span>
        <span>等位分：{{ examscore }}</span>
        <span>位次：{{
            userform.scores
                ? userform.scores.accumulate
                    ? userform.scores.accumulate
                    : 0
                : 0
          }}</span>
      </div>
      <div class="el-dialog-div">
        <el-form :inline="true" :model="formInlinezyz" class="demo-form-inline">
          <!-- <el-form-item label="科别:">
            <el-select
              v-model="formInlinezyz.disciplineType"
              placeholder=""
              size="small"
              disabled
              style="width: 100px; margin-right: 10px"
            >
              <el-option
                v-for="item in disciplineTypeoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批次:">
            <el-select
              v-model="formInlinezyz.admitBatch"
              disabled
              placeholder="不限"
              size="small"
              style="width: 140px; margin-right: 10px"
            >
            </el-select>
          </el-form-item> -->
          <el-form-item label="院校省份:">
            <el-select v-model="formInlinezyz.collegeProvinceId" placeholder="不限" size="small" clearable
                       style="width: 100px; margin-right: 10px">
              <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业组名称:">
            <el-input v-model="formInlinezyz.professionalGroup" placeholder="请输入专业组名称或代码" size="small"
                      style="width: 180px"></el-input>
          </el-form-item>
          <el-form-item label="院校特性:">
            <el-select v-model="collegeCharacter1" placeholder="不限" multiple @change="changecollegeCharacter1"
                       size="small" style="width: 220px; margin-right: 10px">
              <el-option v-for="item in optionsCharacter" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分段:">
            <el-input v-model="formInlinezyz.scoreMin" placeholder="最低分" size="small" style="width: 70px"></el-input>
            -
            <el-input v-model="formInlinezyz.scoreMax" placeholder="最高分" size="small"
                      style="width: 70px; margin-right: 10px"></el-input>
          </el-form-item>
          <el-form-item label="位次:">
            <el-input v-model="formInlinezyz.accumulateMin" placeholder="最低位" size="small" style="width: 70px">
            </el-input>
            -
            <el-input v-model="formInlinezyz.accumulateMax" placeholder="最高位" size="small"
                      style="width: 70px; margin-right: 10px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="pageoptions">搜索</el-button>
            <el-button size="small" type="primary" @click="sureOptions">确定</el-button>
          </el-form-item>
        </el-form>
        <el-table :stripe="true" ref="optionsTable" size="mini" :data="gridDatazyz" max-height="460px" border
                  @select-all="selectallzyz" :row-key="getRowKeys" @select="handleSelectionChangeOptions"
                  @row-click="handleRowSelectionChangeOptions"
                  :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                  :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
          <el-table-column type="selection" :reserve-selection="true" width="80"></el-table-column>
          <!-- <el-table-column
            prop="collegeCode"
            label="院校代码"
            min-width="80"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="collegeName"
            label="院校名称"
            min-width="100"
            :show-overflow-tooltip="true"
          ></el-table-column> -->
          <el-table-column prop="specialtyNames" label="专业组代码" width="100"></el-table-column>
          <el-table-column prop="specialtyOptions" :show-overflow-tooltip="true" label="专业组名称" min-width="150">
          </el-table-column>
          <el-table-column label="包含专业" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.specialtyName ? scope.row.specialtyName : "无" }}
            </template>
          </el-table-column>
          <el-table-column label="选考科目要求" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
              <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="collegeCity" label="所在城市" width="80"
                           :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="院校特性" width="220">
            <template slot-scope="scope">
              <span v-if="scope.row.collegeCharacter &&
                scope.row.collegeCharacter.includes('2')
                ">985 </span>
              <span v-if="scope.row.collegeCharacter &&
                scope.row.collegeCharacter.includes('1')
                ">211 </span>
              <span v-if="scope.row.collegeCharacter &&
                scope.row.collegeCharacter.includes('3')
                ">双一流</span>
            </template>
          </el-table-column>


          <!-- <el-table-column prop="admitBatch" label="录取批次" min-width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column
            label="高考成绩"
            width="65"
          >
          <template>
              {{examscore ? examscore : 0}}
            </template></el-table-column> -->
          <el-table-column prop="scoreYearThis" :label="admissionYear + '最低分'" width="65"></el-table-column>
          <!-- <el-table-column
            prop="scoreYearLast"
            :label="year - 2 + '最低分'"
            width="65"
          ></el-table-column> -->
          <el-table-column prop="accumulateYearThis" :label="admissionYear + '最低位次'" width="68"></el-table-column>
          <el-table-column prop="accumulateYearLast" :label="admissionYear - 1 + '最低位次'"
                           width="68"></el-table-column>
          <el-table-column prop="accumulateYearOther" :label="admissionYear - 2 + '最低位次'"
                           width="68"></el-table-column>
          <el-table-column prop="planYearLast" :label="planYear - 1 + '计划数'" width="65"></el-table-column>
          <el-table-column prop="planYearThis" :label="planYear + '计划数'" width="65"></el-table-column>
          <el-table-column prop="planDiff" label="计划增减" width="68"></el-table-column>
        </el-table>
        <el-pagination background @current-change="handleChangezyz" :current-page.sync="formInlinezyz.current"
                       layout="prev, pager, next" :total="totalzyz" :page-size="500">
        </el-pagination>
        <div>已经选择{{ chooseoptions ? chooseoptions.length : '0' }}个专业组</div>
      </div>
    </el-dialog>
    <!-- 专业组志愿 -->
    <el-dialog title="志愿专业" :visible.sync="dialogTableVisiblezyztable" width="90%" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="el-dialog-div">
        <div style="margin-bottom: 10px; float: right">
          <el-button size="small" type="primary" @click="addOptions">添加专业组</el-button>
        </div>
        <div>
          <el-table :data="gridDatazyztable" border :stripe="true" size="mini" max-height="350px"
                    :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                    :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <!-- <el-table-column
              prop="collegeName"
              label="院校名称"
              :show-overflow-tooltip="true"
              min-width="120"
            ></el-table-column> -->
            <el-table-column prop="specialtyNames" label="专业组代码" width="100"></el-table-column>
            <el-table-column prop="specialtyOptions" :show-overflow-tooltip="true" label="专业组名称" min-width="150">
            </el-table-column>
            <el-table-column label="包含专业" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.specialtyName1 ? scope.row.specialtyName1 : "无" }}
              </template>
            </el-table-column>
            <el-table-column label="选考科目要求" min-width="150" show-overflow-tooltip>0
              <template slot-scope="scope">
                <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
                <span>{{ scope.row.requiredDiscipline }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="scoreYearThis" :label="year + '最低分'" width="65"></el-table-column>
            <!-- <el-table-column
              prop="scoreYearLast"
              :label="year - 2 + '最低分'"
              width="65"
            ></el-table-column> -->
            <el-table-column prop="accumulateYearThis" :label="year + '最低位次'" width="68"></el-table-column>
            <el-table-column prop="accumulateYearLast" :label="year - 1 + '最低位次'" width="68"></el-table-column>
            <el-table-column prop="accumulateYearOther" :label="year - 2 + '最低位次'" width="68"></el-table-column>
            <el-table-column prop="planYearLast" :label="nowyear - 1 + '计划数'" width="65"></el-table-column>
            <el-table-column prop="planYearThis" :label="nowyear + '计划数'" width="65"></el-table-column>
            <el-table-column prop="planDiff" label="计划增减" width="68"></el-table-column>
            <el-table-column label="操作" width="60">
              <template slot-scope="scope">
                <el-button style="font-size: 14px" type="text" @click="delschooloptions(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <!-- 志愿专业 -->
    <el-dialog title="志愿专业" :visible.sync="dialogTableVisible2" width="90%" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="el-dialog-div">
        <div style="margin-bottom: 10px; float: right">
          <el-button size="small" type="primary" @click="showselectSpecialtyList">添加专业</el-button>
          <!-- <el-button size="small" type="primary" @click="savemajor"
            >保存</el-button
          > -->
        </div>
        <div>
          <el-table :data="gridDatazy" border :stripe="true" size="mini" max-height="350px"
                    :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                    :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="collegeName" label="院校名称" :show-overflow-tooltip="true" width="120">
            </el-table-column>
            <el-table-column prop="specialtyNames" label="专业组代码" width="100" v-if="voPa === 3"></el-table-column>
            <el-table-column prop="specialtyOptions" :show-overflow-tooltip="true" label="专业组名称" width="150"
                             v-if="voPa === 3"></el-table-column>
            <el-table-column prop="specialtyCode" label="专业代码" width="100"></el-table-column>
            <el-table-column prop="specialtyName" label="专业名名称" :show-overflow-tooltip="true" min-width="180">
            </el-table-column>
            <el-table-column label="选考科目要求" min-width="150" show-overflow-tooltip>0
              <template slot-scope="scope">
                <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
                <span>{{ scope.row.requiredDiscipline }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="scoreYearThis" :label="year + '最低分'" width="65"></el-table-column>
            <!-- <el-table-column
              prop="scoreYearLast"
              :label="year - 2 + '最低分'"
              width="65"
            ></el-table-column> -->
            <el-table-column prop="accumulateYearThis" :label="year + '最低位次'" width="68"></el-table-column>
            <el-table-column prop="accumulateYearLast" :label="year - 1 + '最低位次'" width="68"></el-table-column>
            <el-table-column prop="accumulateYearOther" :label="year - 2 + '最低位次'" width="68"></el-table-column>
            <el-table-column prop="planYearLast" :label="nowyear - 1 + '计划数'" width="65"></el-table-column>
            <el-table-column prop="planYearThis" :label="nowyear + '计划数'" width="65"></el-table-column>
            <el-table-column prop="planDiff" label="计划增减" width="68"></el-table-column>
            <el-table-column label="排序" width="80" v-if="voPa !== 2">
              <template slot-scope="scope">
                <input size="small" v-model="scope.row.psort" @blur="changesortmajorList(scope.$index)"
                       style="width: 16px;text-align:center;padding-left:10px;padding-right:10px"> </input>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button style="font-size: 14px" type="text" @click="delmajor(scope.$index, scope.row.psort)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <!-- 添加专业 -->
    <el-dialog :title="'添加专业' + formInlinezy.admitBatch" :visible.sync="dialogTableVisible4" width="90%"
               :close-on-click-modal="false" :close-on-press-escape="false" @closed="closedzy">
      <div class="top">
        <span>学生姓名：{{ userform.realName }}</span>
        <span>联系电话：{{ userform.contactPhone }}</span>
        <span>性别：{{ userform.sex === 0 ? "男" : "女" }}</span>
        <span v-if="userform.disciplineType === 1">科别：理科</span>
        <span v-if="userform.disciplineType === 2">科别：文科</span>
        <span v-if="userform.disciplineType === 0 ||
          userform.disciplineType === 3 ||
          userform.disciplineType === 4
          ">科目：<span v-if="userform.discipline.indexOf('物理') !== -1">物理 </span><span
            v-if="userform.discipline.indexOf('历史') !== -1">历史 </span>
          <span v-if="userform.discipline.indexOf('化学') !== -1">化学 </span><span
              v-if="userform.discipline.indexOf('生物') !== -1">生物 </span>
          <span v-if="userform.discipline.indexOf('政治') !== -1">政治 </span><span
              v-if="userform.discipline.indexOf('地理') !== -1">地理 </span></span>
        <span>所在中学：{{ userform.schoolName }}</span>
        <span>毕业年份：{{ userform.graduateYear }}</span>
        <span>高考成绩：{{ userform.adminScore ? userform.adminScore : 0 }}</span>
        <span>等位分：{{ examscore }}</span>
        <span>位次：{{
            userform.scores
                ? userform.scores.accumulate
                    ? userform.scores.accumulate
                    : 0
                : 0
          }}</span>
      </div>
      <div class="el-dialog-div">
        <el-form :inline="true" :model="formInlinezy" class="demo-form-inline">
          <!-- <el-form-item v-if="formInlinezy.collegeName">
            <el-button size="small" type="info" disabled>{{
              formInlinezy.collegeName
            }}</el-button>
          </el-form-item> -->
          <!-- <el-form-item label="科别:">
            <el-select
              v-model="formInlinezy.disciplineType"
              placeholder=""
              size="small"
              disabled
              style="width: 100px; margin-right: 10px"
            >
              <el-option
                v-for="item in disciplineTypeoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="批次:">
            <el-select
              v-model="formInlinezy.admitBatch"
              disabled
              placeholder="不限"
              size="small"
              style="width: 140px; margin-right: 10px"
            >
            </el-select>
          </el-form-item> -->
          <el-form-item label="院校省份:">
            <el-select v-model="formInlinezy.collegeProvinceId" placeholder="不限" size="small" clearable
                       style="width: 100px; margin-right: 10px">
              <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="院校名称:" v-if="voPa !== 3">
            <el-input v-model="formInlinezy.universityName" placeholder="请输入院校名称或代码" size="small"
                      style="width: 180px">
            </el-input>
          </el-form-item>
          <el-form-item label="专业组名称:" v-if="voPa === 3 && iseidt !== 2">
            <el-input v-model="formInlinezy.professionalGroup" placeholder="请输入专业组名称或代码" size="small"
                      style="width: 180px"></el-input>
          </el-form-item>
          <el-form-item label="院校特性:">
            <el-select v-model="collegeCharacter" placeholder="不限" multiple @change="changecollegeCharacter2"
                       size="small"
                       style="width: 220px; margin-right: 10px">
              <el-option v-for="item in optionsCharacter" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业名称:">
            <el-input v-model="formInlinezy.keyWord" placeholder="请输入专业名称或代码" size="small"
                      style="width: 180px">
            </el-input>
          </el-form-item>
          <el-form-item label="分段:">
            <el-input v-model="formInlinezy.scoreMin" placeholder="最低分" size="small" style="width: 70px"></el-input>
            -
            <el-input v-model="formInlinezy.scoreMax" placeholder="最高分" size="small"
                      style="width: 70px; margin-right: 10px"></el-input>
          </el-form-item>
          <el-form-item label="位次:">
            <el-input v-model="formInlinezy.accumulateMin" placeholder="最低位" size="small" style="width: 70px;">
            </el-input>
            -
            <el-input v-model="formInlinezy.accumulateMax" placeholder="最高位" size="small"
                      style="width: 70px;margin-right: 10px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="selectSpecialtyList">搜索</el-button>
            <el-button size="small" type="primary" @click="sureaddzy">确定</el-button>
          </el-form-item>
        </el-form>
        <el-table ref="table" :stripe="true" size="mini" :data="gridDatazy1" :row-key="getRowKeys1" border
                  max-height="460px" @select-all="selectall" @select="handleSelectionChangezy"
                  @row-click="handleRowSelectionChangezy"
                  :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                  :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
          <el-table-column type="selection" width="80" :reserve-selection="true"></el-table-column>
          <el-table-column prop="collegeCode" label="院校代码" width="100" v-if="voPa !== 3"></el-table-column>
          <el-table-column prop="collegeName" label="院校名称" :show-overflow-tooltip="true"
                           width="200"></el-table-column>
          <el-table-column prop="collegeCity" label="所在城市" width="80"
                           :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="院校特性" width="220" v-if="voPa !== 3">
            <template slot-scope="scope">
              <span v-if="scope.row.collegeCharacter &&
                scope.row.collegeCharacter.includes('2')
                ">985 </span>
              <span v-if="scope.row.collegeCharacter &&
                scope.row.collegeCharacter.includes('1')
                ">211 </span>
              <span v-if="scope.row.collegeCharacter &&
                scope.row.collegeCharacter.includes('3')
                ">双一流</span>
            </template>
          </el-table-column>
          <el-table-column prop="specialtyNames" label="专业组代码" width="100" v-if="voPa === 3"></el-table-column>
          <el-table-column prop="specialtyOptions" :show-overflow-tooltip="true" label="专业组名称" width="150"
                           v-if="voPa === 3"></el-table-column>
          <el-table-column label="包含专业" min-width="120" show-overflow-tooltip v-if="voPa === 3">
            <template slot-scope="scope">
              {{ scope.row.specialtyName1 ? scope.row.specialtyName1 : "无" }}
            </template>
          </el-table-column>
          <el-table-column label="选考科目要求" width="150" show-overflow-tooltip v-if="voPa === 3">
            <template slot-scope="scope">
              <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
              <span>{{ scope.row.requiredDiscipline }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="specialtyCode" label="专业代码" width="100"></el-table-column>
          <el-table-column prop="specialtyName" label="专业名称" min-width="180" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="选考科目要求" width="150" show-overflow-tooltip v-if="voPa === 2">
            <template slot-scope="scope">
              <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
              <span>{{ scope.row.requiredDiscipline }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="admitBatch" label="录取批次" :show-overflow-tooltip="true" width="80"></el-table-column> -->
          <el-table-column prop="scoreYearThis" :label="admissionYear + '最低分'" width="65"></el-table-column>
          <!-- <el-table-column
            prop="scoreYearLast"
            :label="year - 2 + '最低分'"
            width="65"
          ></el-table-column> -->
          <el-table-column prop="accumulateYearThis" :label="admissionYear + '最低位次'" width="68"></el-table-column>
          <el-table-column prop="accumulateYearLast" :label="admissionYear - 1 + '最低位次'"
                           width="68"></el-table-column>
          <el-table-column prop="accumulateYearOther" :label="admissionYear - 2 + '最低位次'"
                           width="68"></el-table-column>
          <el-table-column prop="planYearLast" :label="planYear - 1 + '计划数'" width="65"></el-table-column>
          <el-table-column prop="planYearThis" :label="planYear + '计划数'" width="65"></el-table-column>
          <el-table-column prop="planDiff" label="计划增减" width="68"></el-table-column>
        </el-table>
        <div style="margin-top:10px">已经选择{{ Specialty.length }}个专业</div>
        <el-pagination style="margin-top:10px" background @current-change="handleChangezy"
                       :current-page.sync="formInlinezy.current" layout="prev, pager, next" :total="totalzy"
                       :page-size="500">
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 保存志愿 -->
    <el-dialog title="保存志愿" :visible.sync="dialogFormVisible" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="templateInfo">
        <el-form-item label="志愿方案名称:" label-width="140px">
          <el-input v-model="templateInfo.planName" size="small" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="志愿方案备注:" label-width="140px">
          <el-select clearable v-model="templateInfo.remark" size="small" placeholder="请选择"
                     style="width: 200px; margin-right: 20px">
            <el-option v-for="item in planRemarkList" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="savedraft" size="small">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from "@/util/request";
import {
  getDraftList,
  getTemplatePlanDetail,
  getProvincePage,
  getStudentDetail,
  previewAdmitDraft,
  savedraft,
  selectCollegeList,
  selectCollegeOptionsList,
  selectCollegeSpecialtyList,
  selectEqualScore,
  selectSpecialtyOptionsList,
  selectSpecialtyOptionsListV2,
  systemAssess,
} from "@/api/serviceManagement.js";
import { obtainKeyword } from "@/api/systemManagement.js";
import { getProvinceList } from "@/api/index.js";
import volunteerViewTable from "./components/volunteerViewTable.vue";

export default {
  components: {
    volunteerViewTable,
  },
  data() {
    return {
      nowyear: 2021,
      total: 0,
      totalzy: 0,
      totalzyz: 0,
      temform:{},
      formInlinezyz: { size: 500, current: 1 }, //专业组筛选条件
      collegeCharacter1: [],
      examscore: 0, //高考成绩等位分
      collegeCharacter: [], //选择院校特性
      optionscategory: [], //门类
      optionsdiscipline: [], //专业类
      formInline: { size: 500, current: 1, collegeCharacter: "" }, //院校筛选条件
      formInlinezy: { size: 500, current: 1 }, //专业筛选条件
      activeName: "", //tabs选中 批次
      ismajor: 0, //1直接添加专业 0
      disciplineTypeoptions: [
        { label: "不分文理", value: 0 },
        { label: "理科", value: 1 },
        { label: "文科", value: 2 },
        { label: "物理类", value: 3 },
        { label: "历史类", value: 4 },
      ], //科别
      voPa: 0, //志愿模式 1院校 2专业 3专业组
      dialogTableVisible: false, //添加志愿
      dialogTableVisible1: false, //添加院校
      dialogTableVisible2: false, //志愿专业
      dialogTableVisible4: false, //添加专业
      dialogTableVisiblezyz: false, //添加专业组
      gridDatazyz: [], //专业组
      templateInfo: {}, //志愿
      dialogFormVisible: false,
      gridData: [], //确认院校志愿
      gridData1: [], //所有院校志愿
      gridDatazy: [], //确认专业志愿
      gridDatazy1: [], //所有专业
      optionsCharacter: [
        { label: "211", value: "1" },
        { label: "985", value: "2" },
        { label: "双一流", value: "3" },
      ], //院校特性
      userform: {}, //学生信息
      batchs: [], //批次
      options: [], //方案记录
      value: "", //选中方案记录
      options1: [], //高校省份
      draftId: "", //志愿id
      year: new Date().getFullYear(),
      planYear: 0, //最近招生计划年份
      admissionYear: 0, //最近录取数据年份
      chooseschool: [], //选择的学校
      Specialty: [], //选择的专业
      idOne: "", //一对一服务id
      iseidt: 0, //判断添加专业位置 1直接添加 2通过学校添加
      data: {}, //志愿详情
      planRemarkList: [],
      chooseoptions: [], //专业组选择
      istype: 0, //专业组1列表里添加 0外部添加
      dialogTableVisiblezyztable: false, //专业组展示
      gridDatazyztable: [], //专业组
      id: "",
      batch: "",
      currentBatch: {}, //当前批次
      draftCollegeList: [],
      newChooseoptions: [], //新选择的专业组
      oldChooseoptions: [],
      autoSelectSpecialtyIndex: 0,
    };
  },
  watch: {
    $route(val) {
      if (val.path === "/viewVolunteerPlan") {
        this.formInline = { collegeCharacter: "" };
        this.formInlinezy = {};
        this.templateInfo = {};
        this.id = this.$route.query.id;
        this.idOne = this.$route.query.idOne;
        this.draftId = this.$route.query.draftId;
        if (this.draftId) {
          this.templateInfo.draftId = this.draftId;
        }
        this.batch = this.$route.query.batch;
        this.voPa = this.$route.query.voPa - 0;
        this.templateInfo.remark = this.$route.query.remark;
        this.templateInfo.planName = this.$route.query.planName;
        if (this.id) {
          this.getStudentDetail(this.id);
        }
      }
    },
  },
  mounted() {
    this.getyear();
    this.id = this.$route.query.id;
    this.idOne = this.$route.query.idOne;
    this.draftId = this.$route.query.draftId;
    if (this.draftId) {
      this.templateInfo.draftId = this.$route.query.draftId;
    }
    this.batch = this.$route.query.batch;
    this.voPa = this.$route.query.voPa - 0;
    this.templateInfo.remark = this.$route.query.remark;
    this.templateInfo.planName = this.$route.query.planName;
    this.getProvinceList();
    if (this.id) {
      this.getStudentDetail(this.id);
    }
  },
  methods: {
    openDialog() {
      this.temform = {};
    },
    matchRequiredType(requiredType) {
      switch (requiredType) {
        case 0:
          return "不提科目要求";
        case 1:
          return "任选一门报考：";
        case 2:
          return "均报考：";
      }
    },
    // 志愿草稿打印
    exportTemplate(type) {
      let title = "";
      if (type === 1) {
        title = "学校";
      } else if (type === 2) {
        title = "专业";
      } else {
        title = "专业组";
      }
      let data = {
        type: type,
        admitBatch: this.activeName,
        draftId: this.draftId,
        source: 2,
        fraction: 1,
        voPa: this.voPa,
      };
      axios({
        method: "post",
        url: "/com/had-login/aspiration/aspiration-plan/vertical/exportTemplate",
        data: data,
        responseType: "blob",
      })
        .then((res) => {
          const elink = document.createElement("a");
          elink.download =
            this.userform.realName + this.activeName + title + " 草稿志愿.xlsx"; //定义表格名称，后缀是文件格式
          elink.style.display = "none";
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          });
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 专业排序
    changesortmajorList(index) {
      let data = this.gridDatazy[index];
      if (data.psort > this.gridDatazy.length) {
        data.psort = this.gridDatazy.length;
      }
      let psort = index + 1 + "";
      if (data.psort < 0 || data.psort - 0 === NaN) {
        data.psort = psort;
      }
      if (data.psort === psort) {
        return;
      }
      if (data.psort > psort) {
        this.gridDatazy.splice(data.psort, 0, data);
        this.gridDatazy.splice(index, 1);
      } else {
        this.gridDatazy.splice(data.psort - 1, 0, data);
        this.gridDatazy.splice(index + 1, 1);
      }
      if (this.gridDatazy && this.gridDatazy.length > 0) {
        this.batchs.forEach((item) => {
          console.log(item, "batchsitem");
          if (item.batch === this.activeName) {
            item.collegeList.forEach((item1) => {
              if (this.voPa !== 3) {
                if (
                  this.gridDatazy[0].collegeName === item1.collegeName &&
                  this.gridDatazy[0].specialtyOptions === item1.specialtyOptions
                ) {
                  this.gridDatazy.forEach((item2, i) => {
                    item2.psort = i + 1;
                  });
                  item1.specialtyList = this.gridDatazy;
                }
              } else {
                if (this.gridDatazy[0].collegeName === item1.collegeName) {
                  if (item1.optionsList && item1.optionsList.length > 0) {
                    item1.optionsList.forEach((options) => {
                      if (
                        this.gridDatazy[0].collegeName ===
                          options.collegeName &&
                        this.gridDatazy[0].specialtyOptions ===
                          options.specialtyOptions
                      ) {
                        this.gridDatazy.forEach((item2, i) => {
                          item2.psort = i + 1;
                        });
                        options.specialtyList = this.gridDatazy;
                        options.specialtyList = this.gridDatazy;
                      }
                    });
                  }
                }
              }
            });
          }
        });
      }
    },
    // 预览
    preview() {
      let routeData = this.$router.resolve({
        path: "/volunteerPreview",
        query: {
          oneId: this.idOne,
          studentId: this.userform.studentId,
          activeName: this.activeName,
          voPa: this.voPa,
          draftId: this.draftId,
          source: 2,
        },
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 获取备注类型
     */
    obtainKeywordList() {
      obtainKeyword({ type: 2 }).then((res) => {
        if (res.code === 1) {
          this.planRemarkList = res.data || [];
        }
      });
    },
    goback() {
      this.$router.push({
        path: "/studentDetails",
        query: { id: this.id, oneId: this.idOne, activeName: "third" },
      });
    },
    getRowKeys(row) {
      return row.specialtyUuid;
    },
    getRowKeys1(row) {
      return row.specialtyUuid;
    },
    // 删除院校专业组
    delschooloptions(index) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.gridDatazyztable.splice(index, 1);
        if (this.gridDatazyztable && this.gridDatazyztable.length > 0) {
          this.batchs.forEach((item) => {
            if (item.batch === this.activeName) {
              item.collegeList.forEach((item1) => {
                if (
                  this.gridDatazyztable[0].collegeName === item1.collegeName
                ) {
                  this.gridDatazyztable.forEach((item2, i) => {
                    item2.sort = i + 1;
                  });
                  item1.optionsList = this.gridDatazyztable;
                }
              });

              this.currentBatch = { ...item };
              this.$refs.volunteerTable.refreshData(
                this.currentBatch.collegeList
              );
            }
          });
        }
        // this.automaticallySaved();
      });
    },
    // 获取专业组
    getOptions(data) {
      console.log(data, "data");
      this.batchs.forEach((item) => {
        if (item.batch === this.activeName) {
          item.collegeList.forEach((college) => {
            college.optionsList = [];
            if (data && data.length > 0) {
              data.forEach((marjor) => {
                if (marjor.collegeName === college.collegeName) {
                  if (marjor.specialtyList && marjor.specialtyList.length > 0) {
                    marjor.specialtyList.forEach((item2) => {
                      item2.sort = marjor.sort;
                    });
                  }
                  college.optionsList.push(marjor);
                }
              });
            }
          });

          this.currentBatch = { ...item };
          this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
          console.log(this.currentBatch, "删除专业组后");
        }
      });
      // this.automaticallySaved();
    },
    // 专业组编辑专业
    editOptionsMarjor(data) {
      this.formInlinezy.collegeCode = data.collegeCode;
      this.formInlinezy.collegeName = data.collegeName;
      this.formInlinezy.specialtyOptions = data.specialtyOptions;
      if (
        data.specialtyList.length === 1 &&
        !data.specialtyList[0].specialtyName
      ) {
        this.gridDatazy = [];
      } else {
        this.gridDatazy = data.specialtyList || [];
      }
      this.dialogTableVisible2 = true;
    },
    addOptionsMarjor(data) {
      console.log("添加专业");
      this.formInlinezy.collegeCode = data.collegeCode;
      this.formInlinezy.collegeName = data.collegeName;
      this.formInlinezy.specialtyOptions = data.specialtyOptions;
      this.formInlinezy.professionalGroup = null;
      this.gridDatazy = data.specialtyList || [];
      // this.dialogTableVisible2 = true;
      this.Specialty = this.gridDatazy ? [...this.gridDatazy] : [];
      this.Specialty = this.Specialty.filter((item) => {
        return item.specialtyName;
      });
      console.log(this.Specialty, "已选专业");
      this.ismajor = 0;
      this.selectSpecialtyList();
      // this.dialogTableVisible4 = true;
      this.iseidt = 2;
    },
    // // 展示保存志愿弹窗
    // showsavedraft() {
    //   this.dialogFormVisible = true;
    //   this.obtainKeywordList();
    //   if (this.draftId) {
    //     this.templateInfo.planName = this.data.planName;
    //     this.templateInfo.remark = this.data.remark;
    //     this.templateInfo.draftId = this.draftId;
    //   } else {
    //     this.templateInfo.planName = "";
    //     this.templateInfo.remark = "";
    //   }
    //   this.templateInfo = { ...this.templateInfo };
    // },
    // 自动保存
    automaticallySaved() {
      this.templateInfo.admitBatch = this.batch;
      this.templateInfo.year = this.userform.graduateYear;
      this.templateInfo.studentId = this.userform.studentId;
      this.templateInfo.oneId = this.idOne;
      this.templateInfo.provinceId = this.userform.province;
      this.templateInfo.province = this.userform.examProvince;
      this.templateInfo.batchs = this.batchs;
      this.templateInfo = { ...this.templateInfo };
      savedraft(this.templateInfo).then((res) => {
        if (res.code === 1) {
          this.$message({
            message: "保存成功，正在刷新方案",
            type: "success",
          });
          this.draftId = this.templateInfo.draftId = res.data || "";
          this.getTemplatePlanDetail(this.draftId);
        }
      });
    },
    //添加志愿
    savedraft() {
      this.templateInfo.admitBatch = this.batch;
      this.templateInfo.year = this.userform.graduateYear;
      this.templateInfo.studentId = this.userform.studentId;
      this.templateInfo.oneId = this.idOne;
      this.templateInfo.provinceId = this.userform.province;
      this.templateInfo.province = this.userform.examProvince;
      this.templateInfo.batchs = this.batchs;
      savedraft(this.templateInfo).then((res) => {
        console.log(res, "志愿草稿");
        if (res.code === 1) {
          this.dialogFormVisible = false;
          this.$router.push({
            path: "/studentDetails",
            query: { id: this.id, oneId: this.idOne, activeName: "third" },
          });
        }
      });
    },
    //院校删除专业志愿
    delmajor(index, psort) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.voPa !== 3) {
          if (this.voPa === 1) {
            console.log("1");
            if (this.gridDatazy && this.gridDatazy.length > 0) {
              this.batchs.forEach((item) => {
                console.log(item, "batchsitem");
                if (item.batch === this.activeName) {
                  item.collegeList.forEach((item1) => {
                    if (
                      this.gridDatazy[0].collegeName === item1.collegeName &&
                      this.gridDatazy[0].specialtyOptions ===
                        item1.specialtyOptions
                    ) {
                      this.gridDatazy.splice(index, 1);
                      this.gridDatazy.forEach((item2, i) => {
                        item2.psort = i + 1;
                      });
                      if (this.gridDatazy && this.gridDatazy.length > 0) {
                        item1.specialtyList = this.gridDatazy;
                      } else {
                        item1.specialtyList = [
                          {
                            collegeCode: item1.collegeCode,
                            collegeName: item1.collegeName,
                            specialtyOptions: "",
                            admitBatch: item1.admitBatch,
                            requiredType: item1.requiredType,
                            specialtyUuid: item1.collegeName,
                            sort: item1.sort,
                            requiredDiscipline: item1.requiredDiscipline,
                            scoreYearThis2: item1.scoreYearThis,
                            accumulateYearThis2: item1.accumulateYearThis,
                            accumulateYearLast2: item1.accumulateYearLast,
                            accumulateYearOther2: item1.accumulateYearOther,
                            planYearLast2: item1.planYearLast,
                            planYearThis2: item1.planYearThis,
                            planDiff2: item1.planDiff,
                          },
                        ];
                      }
                    }
                  });
                }
              });
            }
          }
          if (this.voPa === 2) {
            console.log("2");
            if (this.gridDatazy && this.gridDatazy.length > 0) {
              this.batchs.forEach((item) => {
                if (item.batch === this.activeName) {
                  item.collegeList.forEach((item1) => {
                    if (
                      this.gridDatazy[0].collegeName === item1.collegeName &&
                      this.gridDatazy[0].specialtyOptions ===
                        item1.specialtyOptions
                    ) {
                      this.gridDatazy.splice(index, 1);
                      // this.gridDatazy.forEach((item2, i) => {
                      //   item2.psort = i + 1;
                      // });
                      if (this.gridDatazy && this.gridDatazy.length > 0) {
                        item1.specialtyList = this.gridDatazy || [];
                      } else {
                        item1.specialtyList = [
                          {
                            collegeCode: item1.collegeCode,
                            collegeName: item1.collegeName,
                            specialtyOptions: "",
                            admitBatch: item1.admitBatch,
                            requiredType: item1.requiredType,
                            specialtyUuid: item1.collegeName,
                            sort: item1.sort,
                            requiredDiscipline: item1.requiredDiscipline,
                            scoreYearThis2: item1.scoreYearThis,
                            accumulateYearThis2: item1.accumulateYearThis,
                            accumulateYearLast2: item1.accumulateYearLast,
                            accumulateYearOther2: item1.accumulateYearOther,
                            planYearLast2: item1.planYearLast,
                            planYearThis2: item1.planYearThis,
                            planDiff2: item1.planDiff,
                          },
                        ];
                      }
                    }
                  });
                }
                if (item.collegeList && item.collegeList.length > 0) {
                  item.collegeList.forEach((school) => {
                    school.specialtyList.forEach((major) => {
                      if (major.psort > psort) {
                        major.psort = major.psort - 1;
                      }
                    });
                  });
                }
              });
            }
          }
        } else {
          console.log("3");
          if (this.gridDatazy && this.gridDatazy.length > 0) {
            this.batchs.forEach((item) => {
              if (item.batch === this.activeName) {
                item.collegeList.forEach((item1) => {
                  if (this.gridDatazy[0].collegeName === item1.collegeName) {
                    item1.optionsList.forEach((options) => {
                      if (
                        this.gridDatazy[0].collegeName ===
                          options.collegeName &&
                        this.gridDatazy[0].specialtyOptions ===
                          options.specialtyOptions
                      ) {
                        this.gridDatazy.splice(index, 1);
                        this.gridDatazy.forEach((item2, i) => {
                          item2.psort = i + 1;
                        });
                        if (this.gridDatazy && this.gridDatazy.length > 0) {
                          options.specialtyList = this.gridDatazy;
                        } else {
                          options.specialtyList = [
                            {
                              collegeCode: options.collegeCode,
                              collegeName: options.collegeName,
                              specialtyNames: options.specialtyNames,
                              specialtyOptions: options.specialtyOptions,
                              admitBatch: options.admitBatch,
                              requiredType: options.requiredType,
                              specialtyUuid: options.specialtyOptions,
                              sort: options.sort,
                              requiredDiscipline: options.requiredDiscipline,
                              scoreYearThis2: options.scoreYearThis,
                              accumulateYearThis2: options.accumulateYearThis,
                              accumulateYearLast2: options.accumulateYearLast,
                              accumulateYearOther2: options.accumulateYearOther,
                              planYearLast2: options.planYearLast,
                              planYearThis2: options.planYearThis,
                              planDiff2: options.planDiff,
                            },
                          ];
                        }
                      }
                    });
                  }
                });
              }
            });
          }
        }
        this.batchs.forEach((item) => {
          if (item.batch === this.activeName) {
            this.currentBatch = { ...item };
            this.$refs.volunteerTable.refreshData(
              this.currentBatch.collegeList
            );
          }
        });
        // this.automaticallySaved();
      });
    },
    // 专业模式专业删除
    delspecialtyList(allSpecialtyData) {
      console.log(allSpecialtyData, "专业志愿专业删除");
      this.batchs.forEach((item) => {
        if (item.batch === this.activeName) {
          item.collegeList.forEach((college) => {
            college.specialtyList = [];
            if (allSpecialtyData && allSpecialtyData.length > 0) {
              allSpecialtyData.forEach((marjor) => {
                if (
                  marjor.collegeName === college.collegeName &&
                  marjor.specialtyOptions === college.specialtyOptions
                  // && marjor.specialtyName
                ) {
                  college.specialtyList.push(marjor);
                }
              });
            }
          });
          this.currentBatch = { ...item };
          this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
        }
      });
      // this.automaticallySaved();
    },
    specialtyListSort(allSpecialtyData) {
      this.batchs.forEach((item) => {
        if (item.batch === this.activeName) {
          console.log(item, "item");
          item.collegeList.forEach((college) => {
            college.specialtyList = [];
            if (allSpecialtyData && allSpecialtyData.length > 0) {
              allSpecialtyData.forEach((marjor) => {
                if (
                  marjor.collegeName === college.collegeName &&
                  marjor.specialtyOptions === college.specialtyOptions
                  // && marjor.specialtyName
                ) {
                  college.specialtyList.push(marjor);
                }
              });
            }
          });
          this.currentBatch = { ...item };
          this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
        }
      });
    },
    // 添加专业志愿 直接添加专业
    addMajorVolunteerClick() {
      if (this.voPa !== 3) {
        this.ismajor = 1;
        this.formInlinezy.collegeCode = null;
        this.formInlinezy.collegeName = null;
        this.formInlinezy.specialtyOptions = null;
        this.Specialty = [];
        this.batchs.forEach((item) => {
          if (item.batch === this.activeName) {
            if (item.collegeList && item.collegeList.length > 0) {
              item.collegeList.forEach((marjorlist) => {
                if (
                  marjorlist.specialtyList &&
                  marjorlist.specialtyList.length > 0
                ) {
                  this.Specialty = [
                    ...this.Specialty,
                    ...marjorlist.specialtyList,
                  ];
                }
              });
            }
          }
        });
        this.iseidt = 1;
      } else {
        //专业组
        this.iseidt = 1;
        this.ismajor = 1;
        this.formInlinezy.collegeCode = null;
        this.formInlinezy.collegeName = null;
        this.formInlinezy.specialtyOptions = null;
        this.Specialty = [];
        this.batchs.forEach((item) => {
          if (item.batch === this.activeName) {
            if (item.collegeList && item.collegeList.length > 0) {
              item.collegeList.forEach((options) => {
                if (options.optionsList && options.optionsList.length > 0) {
                  options.optionsList.forEach((item) => {
                    if (item.specialtyList && item.specialtyList.length > 0) {
                      this.Specialty = [
                        ...this.Specialty,
                        ...item.specialtyList,
                      ];
                    }
                  });
                }
              });
            }
          }
        });
      }
      //显示弹框  加载数据
      this.dialogTableVisible4 = true;
      // this.selectSpecialtyList();
    },
    // 添加专业组志愿
    addVolunteerOptionsClick(res) {
      this.istype = res.type;
      // type 1列表里添加 0外部添加
      if (res.type === 0) {
        this.chooseoptions = [];
        this.batchs.forEach((item) => {
          this.formInlinezyz.collegeName = null;
          if (item.batch === this.activeName) {
            if (item.collegeList && item.collegeList.length > 0) {
              item.collegeList.forEach((item) => {
                if (item.optionsList && item.optionsList.length > 0) {
                  this.chooseoptions = [
                    ...this.chooseoptions,
                    ...item.optionsList,
                  ];
                }
              });
            }
            this.voPa = item.voPa || null;
          }
        });
      } else {
        this.chooseoptions = res.data.optionsList || [];
        this.formInlinezyz.collegeName = res.data.collegeName;
      }
      this.dialogTableVisiblezyz = true;
      this.oldChooseoptions = [];
      let arr = [...this.chooseoptions];
      arr.forEach((item) => {
        this.oldChooseoptions.push(item.specialtyOptions);
      });
      this.formInlinezyz.isOptions = 1;
      this.formInlinezyz.isMinority = this.userform.isMinority;
      this.formInlinezyz.isNationalSpecial = this.userform.isNationalSpecial;
      this.formInlinezyz.isLocalSpecial = this.userform.isLocalSpecial;
      this.formInlinezyz.isUniversitySpecial = this.userform.isUniversitySpecial;
      this.formInlinezyz.colorWeakness = this.userform.colorWeakness;
      if (res.type === 1) {
        this.pageoptions();
      }
      this.selectEqualScore();
    },
    addOptions() {
      this.chooseoptions = this.gridDatazyztable
        ? [...this.gridDatazyztable]
        : [];
      this.istype = 1;
      this.dialogTableVisiblezyz = true;
      this.oldChooseoptions = [];
      let arr = [...this.chooseoptions];
      arr.forEach((item) => {
        this.oldChooseoptions.push(item.specialtyOptions);
      });
      this.formInlinezyz.isOptions = 1;
      this.pageoptions();
      this.selectEqualScore();
    },
    // 关闭选择学校
    closedschool() {
      this.formInline.collegeProvinceId = "";
      this.formInline.scoreMax = "";
      this.formInline.scoreMin = "";
      this.collegeCharacter = [];
      this.formInline.accumulateMax = "";
      this.formInline.accumulateMin = "";
      this.formInline.keyWord = "";
      this.formInline.collegeCharacter = "";
      this.formInline = { ...this.formInline };
    },
    // 关闭选择专业组
    closedoptions() {
      this.formInlinezyz.collegeProvinceId = "";
      this.formInlinezyz.collegeName = "";
      this.formInlinezyz.scoreMax = "";
      this.formInlinezyz.scoreMin = "";
      this.collegeCharacter1 = [];
      this.formInlinezyz.accumulateMax = "";
      this.formInlinezyz.accumulateMin = "";
      this.formInlinezyz.keyWord = "";
      this.formInlinezyz.collegeCharacter = "";
      this.formInlinezyz = { ...this.formInlinezyz };
    },
    // 关闭选择专业
    closedzy() {
      this.formInlinezy.scoreMax = "";
      this.formInlinezy.scoreMin = "";
      this.formInlinezy.accumulateMax = "";
      this.formInlinezy.accumulateMin = "";
      this.formInlinezy.majorName1 = "";
      this.formInlinezy.specialtys = [];
      // this.formInlinezy.specialtyOptions = null;
      this.formInlinezy = { ...this.formInlinezy };
    },
    // 院校特性赛选改变
    changecollegeCharacter(val) {
      console.log(val, "val");
      this.formInline.collegeCharacter = val.join(",");
    },
    changecollegeCharacter2(val) {
      console.log(val, "val");
      this.formInlinezy.collegeCharacter = val.join(",");
    },
    changecollegeCharacter1(val) {
      console.log(val, "val");
      this.formInlinezyz.collegeCharacter = val.join(",");
    },
    // 编辑专业
    showzyzy(data) {
      this.formInlinezy.collegeCode = data.collegeCode;
      this.formInlinezy.collegeName = data.collegeName;
      this.formInlinezy.specialtyOptions = data.specialtyOptions;
      if (
        data.specialtyList.length === 1 &&
        !data.specialtyList[0].specialtyName
      ) {
        this.gridDatazy = [];
      } else {
        this.gridDatazy = data.specialtyList || [];
      }
      this.dialogTableVisible2 = true;
    },
    // 专业组模式编辑专业组
    editOptions(data) {
      this.formInlinezyz.collegeName = data.collegeName;
      this.gridDatazyztable = data.optionsList || [];
      this.dialogTableVisiblezyztable = true;
    },
    // 显示选择专业及回显
    showselectSpecialtyList() {
      this.Specialty = this.gridDatazy ? [...this.gridDatazy] : [];
      this.ismajor = 0;
      this.selectSpecialtyList();
      this.iseidt = 2;
    },
    // 确认添加专业
    sureaddzy() {
      console.log(
        "iseidt：" + this.iseidt + "，voPa：" + this.voPa,
        "确定专业选择"
      );
      console.log([...this.Specialty], "确定已选专业");
      if (this.Specialty.length === 0) {
        this.$message({
          message: "请先选择专业",
          type: "warning",
        });
        return;
      }
      if (this.iseidt === 2) {
        if (this.voPa !== 3) {
          this.batchs.forEach((item) => {
            if (item.batch === this.activeName) {
              item.collegeList.forEach((school) => {
                if (this.Specialty && this.Specialty.length > 0) {
                  if (
                    school.collegeName === this.Specialty[0].collegeName &&
                    school.specialtyOptions ===
                      this.Specialty[0].specialtyOptions
                  ) {
                    if (
                      this.Specialty.length > 1 &&
                      !this.Specialty[0].specialtyName
                    ) {
                      this.Specialty.splice(0, 1);
                    }
                    school.specialtyList = [...this.Specialty] || [];
                    // school.specialtyList.sort(function (c, d) {
                    //   return d.scoreYearThis - c.scoreYearThis;
                    // });
                    school.specialtyList.forEach((specialty, i) => {
                      specialty.scoreCollege = school.scoreYearThis;
                      if (this.voPa !== 2) {
                        specialty.sort = school.sort;
                      }
                      if (this.voPa === 1) {
                        specialty.psort = i + 1;
                      }
                    });
                    this.gridDatazy = [...school.specialtyList];
                  }
                } else {
                  this.$message({
                    message: "请先选择专业",
                    type: "warning",
                  });
                  return;
                }
              });
            }
          });
        } else {
          // 专业组顺向添加专业
          this.batchs.forEach((item) => {
            if (item.batch === this.activeName) {
              item.collegeList.forEach((school) => {
                if (this.Specialty && this.Specialty.length > 0) {
                  if (school.collegeName === this.Specialty[0].collegeName) {
                    school.optionsList.forEach((option) => {
                      if (
                        option.specialtyOptions ===
                          this.Specialty[0].specialtyOptions &&
                        option.collegeName === this.Specialty[0].collegeName
                      ) {
                        if (
                          this.Specialty.length > 1 &&
                          !this.Specialty[0].specialtyName
                        ) {
                          this.Specialty.splice(0, 1);
                        }
                        option.specialtyList = [...this.Specialty] || [];
                        // option.specialtyList.sort(function (c, d) {
                        //   return d.scoreYearThis - c.scoreYearThis;
                        // });
                        option.specialtyList.forEach((specialty, i) => {
                          specialty.scoreCollege = option.scoreYearThis;
                          specialty.sort = option.sort;
                          specialty.psort = i + 1;
                        });
                        this.gridDatazy = [...option.specialtyList];
                      }
                    });
                  }
                } else {
                  this.$message({
                    message: "请先选择专业",
                    type: "warning",
                  });
                }
              });
            }
          });
        }
      }
      // 直接添加
      if (this.iseidt === 1) {
        console.log("直接添加");
        if (this.voPa !== 3) {
          console.log("非专业组添加");
          console.log(this.Specialty, "选择专业");
          this.batchs.forEach((item) => {
            if (item.batch === this.activeName) {
              // 专业模式  专业排序
              if (this.voPa === 2) {
                // this.Specialty.sort(function (a, b) {
                //   return b.scoreYearThis - a.scoreYearThis;
                // });

                this.Specialty.forEach((item, index) => {
                  item.scoreCollege = item.scoreYearThis2;
                  // item.psort = index + 1;
                });
              }
              let chooseschoolNamelist = [];
              if (item.collegeList && item.collegeList.length > 0) {
                item.collegeList.forEach((college) => {
                  chooseschoolNamelist.push(college.collegeName);
                });
              } else {
                item.collegeList = [];
              }
              // 从选择的专业中提取学校
              this.Specialty.forEach((marjor) => {
                if (!chooseschoolNamelist.includes(marjor.collegeName)) {
                  chooseschoolNamelist.push(marjor.collegeName);
                  let obj = {
                    admitBatch: marjor.admitBatch,
                    collegeCode: marjor.collegeCode,
                    collegeName: marjor.collegeName,
                    collegeProvince: marjor.collegeProvince,
                    disciplineType: marjor.disciplineType,
                    planDiff: marjor.planDiff2,
                    accumulateYearLast: marjor.accumulateYearLast2,
                    accumulateYearOther: marjor.accumulateYearOther2,
                    accumulateYearThis: marjor.accumulateYearThis2,
                    scoreYearLast: marjor.scoreYearLast2,
                    scoreYearThis: marjor.scoreYearThis2,
                    scoreCollege: marjor.scoreYearThis2,
                    planYearLast: marjor.planYearLast2,
                    planYearThis: marjor.planYearThis2,
                    specialtyOptions: marjor.specialtyOptions,
                    specialtyNames: marjor.specialtyNames,
                    universityId: marjor.universityId,
                    year: marjor.year,
                    admissionYear: marjor.admissionYear,
                    province: marjor.province,
                    provinceId: marjor.provinceId,
                    specialtyUuid: marjor.collegeUuid,
                  };
                  console.log(obj, "倒推学校");
                  item.collegeList.push(obj);
                }
              });
              // item.collegeList.sort(function (a, b) {
              //   return b.scoreYearThis - a.scoreYearThis;
              // });

              //通过psort是否为空判断旧数据和新添加数据
              //旧数据
              let addedCollegeList = item.collegeList.filter((item) => {
                return item.sort;
              });

              item.collegeList.forEach((schoolchildren, index) => {
                // schoolchildren.sort = index + 1;
                if (!schoolchildren.sort) {
                  schoolchildren.sort = addedCollegeList.length + 1;
                  addedCollegeList.push(schoolchildren);
                }
              });

              item.collegeList.forEach((college) => {
                college.specialtyList = [];
                this.Specialty.forEach((special) => {
                  if (
                    special.collegeName === college.collegeName &&
                    special.specialtyOptions === college.specialtyOptions
                    // && special.specialtyName
                  ) {
                    college.scoreYearThis = special.scoreYearThis2;
                    college.scoreCollege = special.scoreYearThis2;
                    if (
                      college.specialtyList.length === 1 &&
                      !college.specialtyList[0].specialtyName
                    ) {
                      college.specialtyList = [{ ...special }];
                    } else {
                      college.specialtyList.push(special);
                    }
                  }
                });
              });

              // 院校模式 专业排序
              if (this.voPa === 1) {
                item.collegeList.forEach((school) => {
                  // school.specialtyList.sort(function (a, b) {
                  //   return b.scoreYearThis - a.scoreYearThis;
                  // });
                  school.specialtyList.forEach((specialty, index) => {
                    specialty.scoreCollege = specialty.scoreYearThis2;
                    specialty.sort = school.sort;
                    specialty.psort = index + 1;
                  });
                });
              }
            }
          });
        } else {
          console.log("专业组模式直接添加专业");
          // 专业组模式直接添加专业
          this.batchs.forEach((item) => {
            if (item.batch === this.activeName) {
              let chooseschoolNamelist = [];
              if (item.collegeList && item.collegeList.length > 0) {
                item.collegeList.forEach((college) => {
                  chooseschoolNamelist.push(college.collegeName);
                });
              } else {
                item.collegeList = [];
              }
              // 倒推院校
              this.Specialty.forEach((marjor) => {
                if (chooseschoolNamelist.indexOf(marjor.collegeName) === -1) {
                  chooseschoolNamelist.push(marjor.collegeName);
                  let obj = {
                    admitBatch: marjor.admitBatch,
                    collegeCode: marjor.collegeCode,
                    collegeName: marjor.collegeName,
                    collegeProvince: marjor.collegeProvince,
                    disciplineType: marjor.disciplineType,
                    planDiff: marjor.planDiff2,
                    accumulateYearLast: marjor.accumulateYearLast2,
                    accumulateYearOther: marjor.accumulateYearOther2,
                    accumulateYearThis: marjor.accumulateYearThis2,
                    scoreYearLast: marjor.scoreYearLast2,
                    scoreYearThis: marjor.scoreYearThis2,
                    planYearLast: marjor.planYearLast2,
                    planYearThis: marjor.planYearThis2,
                    specialtyOptions: marjor.specialtyOptions,
                    specialtyNames: marjor.specialtyNames,
                    universityId: marjor.universityId,
                    year: marjor.year,
                    admissionYear: marjor.admissionYear,
                    province: marjor.province,
                    provinceId: marjor.provinceId,
                    specialtyUuid: marjor.collegeUuid,
                    optionsList: [],
                  };
                  item.collegeList.push(obj);
                  console.log("倒推院校");
                }
              });
              // item.collegeList.sort(function (a, b) {
              //   return b.scoreYearThis - a.scoreYearThis;
              // });
              item.collegeList.forEach((schoolchildren, index) => {
                schoolchildren.sort = index + 1;
              });
              let chooseoptionsNamelist = [];
              let chooseoptionslist = [];
              if (item.collegeList && item.collegeList.length > 0) {
                item.collegeList.forEach((college) => {
                  if (college.optionsList && college.optionsList.length > 0) {
                    college.optionsList.forEach((ops) => {
                      chooseoptionsNamelist.push(
                        ops.collegeName + ops.specialtyOptions
                      );
                      chooseoptionslist.push(ops);
                    });
                  } else {
                    college.optionsList = [];
                  }
                });
              } else {
                item.collegeList = [];
              }
              // 倒推专业组
              this.Specialty.forEach((marjor) => {
                if (
                  chooseoptionsNamelist.indexOf(
                    marjor.collegeName + marjor.specialtyOptions
                  ) === -1
                ) {
                  chooseoptionsNamelist.push(
                    marjor.collegeName + marjor.specialtyOptions
                  );
                  let obj = {
                    admitBatch: marjor.admitBatch,
                    collegeCode: marjor.collegeCode,
                    collegeName: marjor.collegeName,
                    collegeProvince: marjor.collegeProvince,
                    disciplineType: marjor.disciplineType,
                    planDiff: marjor.planDiff1,
                    accumulateYearLast: marjor.accumulateYearLast1,
                    accumulateYearOther: marjor.accumulateYearOther1,
                    accumulateYearThis: marjor.accumulateYearThis1,
                    scoreYearLast: marjor.scoreYearLast1,
                    scoreYearThis: marjor.scoreYearThis1,
                    planYearLast: marjor.planYearLast1,
                    planYearThis: marjor.planYearThis1,
                    specialtyName: marjor.specialtyName1,
                    specialtyOptions: marjor.specialtyOptions,
                    specialtyNames: marjor.specialtyNames,
                    requiredType: marjor.requiredType,
                    requiredDiscipline: marjor.requiredDiscipline,
                    universityId: marjor.universityId,
                    year: marjor.year,
                    admissionYear: marjor.admissionYear,
                    province: marjor.province,
                    provinceId: marjor.provinceId,
                    specialtyUuid: marjor.collegeUuid,
                    specialtyList: [],
                  };
                  chooseoptionslist.push(obj);
                  console.log("倒推专业组");
                }
              });
              // chooseoptionslist.sort(function (a, b) {
              //   return b.scoreYearThis - a.scoreYearThis;
              // });
              item.collegeList.forEach((schools) => {
                schools.optionsList = [];
              });
              chooseoptionslist.forEach((schoolchildren, index) => {
                schoolchildren.sort = index + 1;
                if (item.collegeList && item.collegeList.length > 0) {
                  item.collegeList.forEach((schools) => {
                    if (schools.collegeName === schoolchildren.collegeName) {
                      schools.optionsList.push(schoolchildren);
                      console.log("放置专业组");
                    }
                  });
                }
              });
              item.collegeList.forEach((schools) => {
                if (schools.optionsList && schools.optionsList.length > 0) {
                  schools.optionsList.forEach((options) => {
                    options.specialtyList = [];
                  });
                }
              });
              // 放置专业
              this.Specialty.forEach((marjor) => {
                if (item.collegeList && item.collegeList.length > 0) {
                  item.collegeList.forEach((schools) => {
                    if (schools.optionsList && schools.optionsList.length > 0) {
                      schools.optionsList.forEach((options) => {
                        if (
                          options.collegeName === marjor.collegeName &&
                          options.specialtyOptions === marjor.specialtyOptions
                        ) {
                          marjor.scoreCollege = options.scoreYearThis;
                          marjor.sort === options.psort;
                          if (
                            options.specialtyList &&
                            options.specialtyList.length > 0 &&
                            !options.specialtyList[0].specialtyName
                          ) {
                            options.specialtyList.splice(0, 1);
                          }
                          options.specialtyList.push(marjor);
                          console.log("放置专业");
                        }
                      });
                    }
                  });
                }
              });
              item.collegeList.forEach((school) => {
                if (school.optionsList && school.optionsList.length > 0) {
                  school.optionsList.forEach((options) => {
                    if (
                      options.specialtyList &&
                      options.specialtyList.length > 0
                    ) {
                      options.specialtyList.forEach((specialty, index) => {
                        specialty.sort = options.sort;
                        specialty.psort = index + 1;
                        console.log("专业排序");
                      });
                    }
                  });
                }
              });
            }
          });
        }
      }
      // 专业排名
      // this.voPa === 2专业志愿
      if (this.voPa === 2) {
        this.batchs.forEach((batch) => {
          if (batch.batch === this.activeName) {
            let marjorArr = [];
            batch.collegeList.forEach((college) => {
              if (
                !college.specialtyList ||
                college.specialtyList.length === 0
              ) {
                //添加空专业
                college.specialtyList = [
                  {
                    collegeCode: college.collegeCode,
                    collegeName: college.collegeName,
                    specialtyOptions: college.specialtyOptions,
                    admitBatch: college.admitBatch,
                    requiredType: college.requiredType,
                    specialtyUuid: college.collegeName,
                    sort: college.sort,
                    requiredDiscipline: college.requiredDiscipline,
                    scoreYearThis2: college.scoreYearThis,
                    accumulateYearThis2: college.accumulateYearThis,
                    accumulateYearLast2: college.accumulateYearLast,
                    accumulateYearOther2: college.accumulateYearOther,
                    planYearLast2: college.planYearLast,
                    planYearThis2: college.planYearThis,
                    planDiff2: college.planDiff,
                    isEmpty: 1,
                  },
                ];
              }

              marjorArr = [...marjorArr, ...college.specialtyList];
            });
            //通过psort是否为空判断旧数据和新添加数据
            //旧数据
            let addedData = marjorArr.filter((item) => {
              return item.psort;
            });
            console.log(addedData.length, "已添加专业数量");
            marjorArr.forEach((marjor, index) => {
              // marjor.psort = index + 1;
              //新添加数据排序在已添加数据后面
              if (!marjor.psort) {
                marjor.psort = addedData.length + 1;
                addedData.push(marjor);
              }
            });

            console.log(marjorArr, "所有专业");

            batch.collegeList.forEach((uni) => {
              uni.specialtyList = [];
              marjorArr.forEach((spe) => {
                if (
                  uni.collegeName === spe.collegeName &&
                  uni.specialtyOptions === spe.specialtyOptions
                  // && spe.specialtyName
                ) {
                  spe.scoreCollege = uni.scoreYearThis;
                  uni.specialtyList.push(spe);
                }
              });
            });
            batch.collegeList = [...batch.collegeList];
            batch = { ...batch };
          }
        });
      }

      this.batchs.forEach((item, index) => {
        if (item.batch === this.activeName) {
          this.currentBatch = { ...item };
          this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
        }
      });
      // this.$refs.volunteerTable.changeswitch();
      this.dialogTableVisible4 = false;
      // this.automaticallySaved();
      //取消自动保存

      // this.batchs.forEach((item) => {
      //   if (item.batch === this.batch) {
      //     this.voPa = item.voPa;
      //     console.log(this.voPa, "this.voPa");
      //     this.batch = this.data.admitBatch;
      //     this.activeName = this.batch; //this.batchs[0].batch;
      //     this.formInline.admitBatch = this.batch; //this.batchs[0].batch;
      //     this.formInlinezy.admitBatch = this.batch; //this.batchs[0].batch;
      //     this.formInlinezyz.admitBatch = this.batch; //this.batchs[0].batch;
      //     this.year = item.collegeList[0].year || this.year;
      //     this.year = 2021;
      //   }
      // });
    },
    // 展示添加专业
    showaddmajor(data) {
      this.formInlinezy.collegeCode = data.collegeCode;
      this.formInlinezy.collegeName = data.collegeName;
      this.formInlinezy.specialtyOptions = data.specialtyOptions;
      this.Specialty = data.specialtyList ? [...data.specialtyList] : [];
      this.Specialty = this.Specialty.filter((item) => {
        return item.specialtyName;
      });
      this.ismajor = 0;
      this.iseidt = 2;
      this.selectSpecialtyList();
    },
    handleChangezy(page) {
      this.formInlinezy.current = page;
      this.selectSpecialtyList();
    },
    handleChangezyz(page) {
      this.formInlinezyz.current = page;
      this.pageoptions();
    },
    async selectSpecialtyList() {
      let res = {};
      console.log(this.ismajor, "this.ismajor");
      console.log("专业添加");
      let arr = [];
      if (this.formInlinezy.majorName1) {
        let specialtyArr = this.formInlinezy.majorName1.split(" ");
        if (specialtyArr) {
          specialtyArr.forEach((item, index) => {
            if (item) {
              arr.push(item);
            }
          });
        }
      } else {
        arr = null;
      }
      this.formInlinezy.specialtys = arr;

      this.formInlinezy.isMinority = this.userform.isMinority;
      this.formInlinezy.isNationalSpecial = this.userform.isNationalSpecial;
      this.formInlinezy.isLocalSpecial = this.userform.isLocalSpecial;
      this.formInlinezy.isUniversitySpecial = this.userform.isUniversitySpecial;
      this.formInlinezy.colorWeakness = this.userform.colorWeakness;

      // if (this.ismajor === 1) {
      if (this.voPa !== 3) {
        res = await selectCollegeSpecialtyList(this.formInlinezy);
      } else {
        // 专业组
        res = await selectSpecialtyOptionsList(this.formInlinezy);
      }
      // } else {
      //   res = await selectSpecialtyList(this.formInlinezy);
      // }
      let data = res.data || {};
      this.totalzy = data.total || 0;
      this.gridDatazy1 = data.records || [];
      if (this.gridDatazy1 && this.gridDatazy1.length > 0) {
        this.planYear = this.gridDatazy1[0].year;
        this.admissionYear = this.gridDatazy1[0].admissionYear;
      }
      let dataparams = [];
      if (this.Specialty && this.Specialty.length > 0) {
        this.Specialty.forEach((item1) => {
          this.gridDatazy1.forEach((item) => {
            if (
              item1.specialtyName === item.specialtyName &&
              item1.collegeName === item.collegeName &&
              item1.specialtyOptions === item.specialtyOptions &&
              item1.specialtyCode === item.specialtyCode
            ) {
              dataparams.push(item);
            }
          });
        });
      }
      this.dialogTableVisible4 = true;
      this.toggleSelection(dataparams, "table");
    },
    //选择专业
    handleSelectionChangezy(arr, row) {
      console.log(row, "row");
      console.log([...this.Specialty], "Specialty147");
      let isHaveItem = this.Specialty.find(
        (item) =>
          item.specialtyName === row.specialtyName &&
          item.collegeName === row.collegeName &&
          row.specialtyOptions === item.specialtyOptions &&
          item.specialtyCode === row.specialtyCode
      );
      console.log(isHaveItem, "isHaveItem");
      if (isHaveItem) {
        this.Specialty = this.Specialty.filter(
          (item) =>
            item.specialtyName !== isHaveItem.specialtyName ||
            item.collegeName !== isHaveItem.collegeName ||
            item.specialtyOptions !== isHaveItem.specialtyOptions ||
            isHaveItem.specialtyCode !== item.specialtyCode
        );
      } else {
        row.psort = null;
        this.Specialty.push(row);
      }
      console.log(this.Specialty, "this.Specialty789");
    },
    handleRowSelectionChangezy(row, col, event) {
      row.flag = !row.flag;
      let isflag = null;
      let marjor = [...this.Specialty];
      console.log(marjor, "选择专业");
      let isHaveItem = this.Specialty.find(
        (item) =>
          row.specialtyName === item.specialtyName &&
          row.collegeName === item.collegeName &&
          row.specialtyOptions === item.specialtyOptions &&
          row.specialtyCode === item.specialtyCode
      );
      console.log(isHaveItem, "isHaveItemzhuanye");
      if (isHaveItem) {
        isflag = false;
        this.Specialty = this.Specialty.filter(
          (item) =>
            isHaveItem.specialtyName !== item.specialtyName ||
            isHaveItem.collegeName !== item.collegeName ||
            isHaveItem.specialtyOptions !== item.specialtyOptions ||
            isHaveItem.specialtyCode !== item.specialtyCode
        );
      } else {
        isflag = true;
        row.psort = null;
        this.Specialty.push(row);
      }
      // this.Specialty = this.Specialty.filter(item => {
      //   return row.collegeName === item.collegeName && (!item.isEmpty || item.isEmpty !== 1)
      // })
      this.$refs.table.toggleRowSelection(row, isflag);
      console.log(this.Specialty, "this.Specialty111");
    },
    //合并去重
    MergeArray(arr1, arr2) {
      var _arr = new Array();
      var uuidArr = [];
      for (var i = 0; i < arr1.length; i++) {
        _arr.push(arr1[i]);
        uuidArr.push(arr1[i].specialtyUuid);
      }
      for (var i = 0; i < arr2.length; i++) {
        if (!uuidArr.includes(arr2[i].specialtyUuid)) {
          _arr.push(arr2[i]);
        }
      }
      return _arr;
    },

    //全选院校
    selectAllCollege(select) {
      if (select.length > 0) {
        this.chooseschool = this.MergeArray(this.chooseschool, select);
      } else {
        this.chooseschool = [];
      }
    },

    // 全选专业
    selectall(select) {
      console.log(select, "添加专业权限");
      if (select.length > 0) {
        this.Specialty = this.MergeArray(this.Specialty, select);
      } else {
        this.Specialty = [];
      }
      // this.Specialty = [...select] || [];
    },
    // 全选专业组
    selectallzyz(select) {
      if (select.length > 0) {
        this.chooseoptions = this.MergeArray(this.chooseoptions, select);
      } else {
        this.chooseoptions = [];
      }
      // this.chooseoptions = select || [];
    },
    // 选择专业组
    handleSelectionChangeOptions(arr, row) {
      let isHaveItem = this.chooseoptions.find(
        (item) =>
          item.collegeName === row.collegeName &&
          item.specialtyOptions === row.specialtyOptions
      );
      if (isHaveItem) {
        this.chooseoptions = this.chooseoptions.filter(
          (item) =>
            item.collegeName !== isHaveItem.collegeName &&
            item.specialtyOptions !== row.specialtyOptions
        );
      } else {
        this.chooseoptions.push(row);
      }
    },
    handleRowSelectionChangeOptions(row, col, event) {
      row.flag = !row.flag;
      let flag = null;
      let school = [...this.chooseoptions];
      console.log(school, "选择学校");
      let isHaveItem = this.chooseoptions.find(
        (item) =>
          item.collegeName === row.collegeName &&
          item.specialtyOptions === row.specialtyOptions
      );
      if (isHaveItem) {
        flag = false;
        this.chooseoptions = this.chooseoptions.filter(
          (item) =>
            item.collegeName !== isHaveItem.collegeName ||
            item.specialtyOptions !== row.specialtyOptions
        );
      } else {
        flag = true;
        this.chooseoptions.push(row);
      }
      this.$refs.optionsTable.toggleRowSelection(row, flag);
    },
    //选择学校
    handleSelectionChangeschool(arr, row) {
      let isHaveItem = this.chooseschool.find(
        (item) =>
          item.collegeName === row.collegeName &&
          item.specialtyOptions === row.specialtyOptions
      );
      if (isHaveItem) {
        this.chooseschool = this.chooseschool.filter(
          (item) =>
            item.collegeName !== isHaveItem.collegeName ||
            item.specialtyOptions !== isHaveItem.specialtyOptions
        );
      } else {
        this.chooseschool.push(row);
      }
      console.log(this.chooseschool, "选择院校改变");
    },
    handleRowSelectionChangeschool(row, col, event) {
      row.flag = !row.flag;
      let flag = null;
      let school = [...this.chooseschool];
      console.log(school, "选择学校");
      let isHaveItem = this.chooseschool.find(
        (item) =>
          item.collegeName === row.collegeName &&
          item.specialtyOptions === row.specialtyOptions
      );
      console.log(isHaveItem, "isHaveItemschool");
      if (isHaveItem) {
        flag = false;
        this.chooseschool = this.chooseschool.filter(
          (item) =>
            item.collegeName !== isHaveItem.collegeName ||
            item.specialtyOptions !== row.specialtyOptions
        );
      } else {
        flag = true;
        this.chooseschool.push(row);
      }
      this.$refs.myTable.toggleRowSelection(row, flag);
    },
    // 确认专业组
    sureOptions() {
      console.log(this.istype, "添加专业组确认");
      if (
        this.userform.graduateYear === 2024 &&
        this.userform.province === "450000"
      ) {
        this.autoSelectSpecialtyIndex = 0;
        this.newChooseoptions = this.chooseoptions.filter((item) => {
          return !this.oldChooseoptions.includes(item.specialtyOptions);
        });
        this.autoSelectSpecialty();
      } else {
        this.addSpecialtyOptions();
      }
    },

    autoSelectSpecialty() {
      selectSpecialtyOptionsListV2({
        collegeName:
          this.newChooseoptions[this.autoSelectSpecialtyIndex].collegeName,
        specialtyOptions:
          this.newChooseoptions[this.autoSelectSpecialtyIndex].specialtyOptions,
        provinceId: this.userform.province,
        admitBatch: this.batch,
        accumulate: this.formInlinezy.accumulate,
        disciplines: this.formInlinezy.disciplines,
        disciplineType: this.userform.disciplineType,
        isMinority: this.userform.isMinority,
        isNationalSpecial: this.userform.isNationalSpecial,
        isLocalSpecial: this.userform.isLocalSpecial,
        isUniversitySpecial: this.userform.isUniversitySpecial,
        colorWeakness: this.userform.colorWeakness,
        year: this.userform.graduateYear,
      }).then((res) => {
        if (res.code === 1) {
          let data = res.data || {};
          let records = data.records || [];
          this.Specialty = [...this.Specialty, ...records];
        }
        this.autoSelectSpecialtyIndex++;
        if (this.autoSelectSpecialtyIndex < this.newChooseoptions.length) {
          this.autoSelectSpecialty();
        } else {
          this.iseidt = 1;
          this.ismajor = 1;
          this.sureaddzy();
          this.dialogTableVisiblezyz = false;
        }
      });
    },

    addSpecialtyOptions() {
      if (this.chooseoptions && this.chooseoptions.length > 0) {
        if (this.istype === 0) {
          this.batchs.forEach((item) => {
            if (item.batch === this.activeName) {
              // this.chooseoptions.sort(function (a, b) {
              //   return b.scoreYearThis - a.scoreYearThis;
              // });
              // this.chooseoptions.forEach((option, index) => {
              //   option.sort = index + 1;
              // });

              //通过psort是否为空判断旧数据和新添加数据
              //旧数据
              let addedOptionsList = [...this.chooseoptions].filter((item) => {
                return item.sort;
              });

              let chooseoptionsNamelist = []; //已经选择院校
              if (item.collegeList && item.collegeList.length > 0) {
                item.collegeList.forEach((college) => {
                  chooseoptionsNamelist.push(college.collegeName);
                });
              } else {
                item.collegeList = [];
              }
              console.log(chooseoptionsNamelist, "已选择院校");

              //从专业组中添加院校
              this.chooseoptions.forEach((options) => {
                if (!options.sort) {
                  options.sort = addedOptionsList.length + 1;
                  addedOptionsList.push(options);
                }

                if (!chooseoptionsNamelist.includes(options.collegeName)) {
                  chooseoptionsNamelist.push(options.collegeName);
                  console.log(options.collegeName, "从专业组中添加院校");
                  let obj = {
                    admitBatch: options.admitBatch,
                    collegeCode: options.collegeCode,
                    collegeName: options.collegeName,
                    collegeProvince: options.collegeProvince,
                    disciplineType: options.disciplineType,
                    planDiff: options.planDiff2,
                    accumulateYearLast: options.accumulateYearLast2,
                    accumulateYearOther: options.accumulateYearOther2,
                    accumulateYearThis: options.accumulateYearThis2,
                    scoreYearLast: options.scoreYearLast2,
                    scoreYearThis: options.scoreYearThis2,
                    planYearLast: options.planYearLast2,
                    planYearThis: options.planYearThis2,
                    specialtyOptions: options.specialtyOptions,
                    specialtyNames: options.specialtyNames,
                    universityId: options.universityId,
                    year: options.year,
                    admissionYear: options.admissionYear,
                    province: options.province,
                    provinceId: options.provinceId,
                    specialtyUuid: options.collegeUuid,
                  };
                  item.collegeList.push(obj);
                }
              });
              console.log(item.collegeList, "添加专业组后院校数据");
              // item.collegeList.sort(function (a, b) {
              //   return b.scoreYearThis - a.scoreYearThis;
              // });

              //通过psort是否为空判断旧数据和新添加数据
              //旧数据
              let addedCollegeList = [...item.collegeList].filter((item) => {
                return item.sort;
              });

              item.collegeList.forEach((schoolchildren, index) => {
                // schoolchildren.sort = index + 1;
                if (!schoolchildren.sort) {
                  schoolchildren.sort = addedCollegeList.length + 1;
                  addedCollegeList.push(schoolchildren);
                }
              });

              //将选择的专业组根据院校名称用map分组
              let map = new Map();
              this.chooseoptions.forEach((item) => {
                if (!map.has(item.collegeName)) {
                  map.set(item.collegeName, []);
                }
                map.get(item.collegeName).push(item);
              });
              console.log(map, "院校专业组");

              item.collegeList.forEach((college) => {
                college.optionsList = map.get(college.collegeName);
                this.chooseoptions.forEach((options) => {
                  if (
                    !options.specialtyList ||
                    options.specialtyList.length < 1
                  ) {
                    options.specialtyList = [
                      {
                        collegeCode: options.collegeCode,
                        collegeName: options.collegeName,
                        specialtyNames: options.specialtyNames,
                        specialtyOptions: options.specialtyOptions,
                        admitBatch: options.admitBatch,
                        requiredType: options.requiredType,
                        specialtyUuid: options.specialtyOptions,
                        sort: options.sort,
                        requiredDiscipline: options.requiredDiscipline,
                        scoreYearThis2: options.scoreYearThis,
                        accumulateYearThis2: options.accumulateYearThis,
                        accumulateYearLast2: options.accumulateYearLast,
                        accumulateYearOther2: options.accumulateYearOther,
                        planYearLast2: options.planYearLast,
                        planYearThis2: options.planYearThis,
                        planDiff2: options.planDiff,
                      },
                    ];
                  }
                  // if (options.collegeName === college.collegeName) {
                  //   college.optionsList.push(options);
                  // }
                });
              });
            }
          });
          // this.automaticallySaved();
        } else {
          this.gridDatazyztable = this.chooseoptions;
          this.batchs.forEach((item) => {
            if (item.batch === this.activeName) {
              let optionsArr = [];
              item.collegeList.forEach((school) => {
                if (school.collegeName === this.chooseoptions[0].collegeName) {
                  school.optionsList = this.chooseoptions;
                }
                if (school.optionsList && school.optionsList.length > 0) {
                  optionsArr = [...optionsArr, ...school.optionsList];
                }
              });
              // optionsArr.sort(function (a, b) {
              //   return b.scoreYearThis - a.scoreYearThis;
              // });
              optionsArr.forEach((options, index) => {
                options.sort = index + 1;
              });
              item.collegeList.forEach((uni) => {
                uni.optionsList = [];
                optionsArr.forEach((spe) => {
                  if (!spe.specialtyList || spe.specialtyList.length < 1) {
                    spe.specialtyList = [
                      {
                        collegeCode: spe.collegeCode,
                        collegeName: spe.collegeName,
                        specialtyNames: spe.specialtyNames,
                        specialtyOptions: spe.specialtyOptions,
                        admitBatch: spe.admitBatch,
                        requiredType: spe.requiredType,
                        specialtyUuid: spe.specialtyOptions,
                        sort: spe.sort,
                        requiredDiscipline: spe.requiredDiscipline,
                        scoreYearThis2: spe.scoreYearThis,
                        accumulateYearThis2: spe.accumulateYearThis,
                        accumulateYearLast2: spe.accumulateYearLast,
                        accumulateYearOther2: spe.accumulateYearOther,
                        planYearLast2: spe.planYearLast,
                        planYearThis2: spe.planYearThis,
                        planDiff2: spe.planDiff,
                      },
                    ];
                  }
                  if (uni.collegeName === spe.collegeName) {
                    uni.optionsList.push(spe);
                  }
                });
              });
            }
          });
        }

        this.batchs.forEach((item) => {
          if (item.batch === this.activeName) {
            this.currentBatch = { ...item };
            this.$refs.volunteerTable.refreshData(
              this.currentBatch.collegeList
            );
          }
        });
        // this.$refs.volunteerTable.changeswitch();
        this.dialogTableVisiblezyz = false;
      } else {
        this.$message({
          message: "请先选择专业组",
          type: "warning",
        });
      }
    },
    // 确认院校
    sureschool() {
      // 院校按最低分排序排序;
      // this.chooseschool.sort(function (a, b) {
      //   return b.scoreYearThis - a.scoreYearThis;
      // });

      if (this.chooseschool.length === 0) {
        this.$message({
          message: "请先选择院校",
          type: "warning",
        });
        return;
      }

      //通过psort是否为空判断旧数据和新添加数据
      //旧数据
      let addedCollegeList = [...this.chooseschool].filter((item) => {
        return item.sort;
      });

      this.chooseschool.forEach((children, index) => {
        if (!children.sort) {
          children.sort = addedCollegeList.length + 1;
          addedCollegeList.push(children);
        }
      });

      this.batchs.forEach((item) => {
        if (item.batch === this.activeName) {
          item.collegeList = [...this.chooseschool] || [];
          if (this.voPa !== 3) {
            item.collegeList.forEach((col) => {
              if (!col.specialtyList || col.specialtyList.length < 1) {
                col.specialtyList = [
                  {
                    collegeCode: col.collegeCode,
                    collegeName: col.collegeName,
                    specialtyOptions: "",
                    admitBatch: col.admitBatch,
                    requiredType: col.requiredType,
                    specialtyUuid: col.collegeName,
                    sort: col.sort,
                    psort: null,
                    requiredDiscipline: col.requiredDiscipline,
                    scoreYearThis2: col.scoreYearThis,
                    accumulateYearThis2: col.accumulateYearThis,
                    accumulateYearLast2: col.accumulateYearLast,
                    accumulateYearOther2: col.accumulateYearOther,
                    planYearLast2: col.planYearLast,
                    planYearThis2: col.planYearThis,
                    planDiff2: col.planDiff,
                    isEmpty: 1,
                  },
                ];
              } else {
                col.scoreYearThis2 = col.specialtyList[0].scoreYearThis2;
              }
            });
          }
          this.currentBatch = { ...item };
          this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
        }
      });
      // this.$refs.volunteerTable.changeswitch();
      this.dialogTableVisible1 = false;
      // this.automaticallySaved();
    },
    // 获取高考等位分
    selectEqualScore() {
      selectEqualScore(this.formInline).then((res) => {
        if (res.code === 1) {
          this.examscore = res.data || 0;
        }
      });
    },
    collegeList(data) {
      this.batchs.forEach((item) => {
        if (item.batch === this.activeName) {
          item.collegeList = [...data] || [];
          this.currentBatch = { ...item };
          this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
        }
      });
      // this.automaticallySaved();
    },
    // 添加院校志愿
    addVolunteerClick() {
      this.chooseschool = [];
      this.batchs.forEach((item) => {
        if (item.batch === this.activeName) {
          if (item.collegeList) {
            this.chooseschool = [...item.collegeList] || [];
          } else {
            this.chooseschool = [];
          }
          // this.voPa = item.voPa || null;
        }
      });
      this.dialogTableVisible1 = true;
      this.formInline.isOptions = 0;
      this.formInline.isMinority = this.userform.isMinority;
      this.formInline.isNationalSpecial = this.userform.isNationalSpecial;
      this.formInline.isLocalSpecial = this.userform.isLocalSpecial;
      this.formInline.isUniversitySpecial = this.userform.isUniversitySpecial;
      this.formInline.colorWeakness = this.userform.colorWeakness;
      // this.pageuniversity();
      this.selectEqualScore();
    },
    // 院校回显
    // 在获取tableData数据的接口中调用
    toggleSelection(rows, refname) {
      this.$nextTick(() => {
        this.$refs[refname].clearSelection();
        if (rows && rows.length > 0) {
          rows.forEach((row) => {
            this.$refs[refname].toggleRowSelection(row, true);
          });
        }
      });
    },
    handleChange(page) {
      this.formInline.current = page;
      this.pageuniversity();
    },
    //获取高校
    pageuniversity() {
      selectCollegeList(this.formInline).then((res) => {
        let data = res.data || {};
        this.total = data.total || 0;
        this.gridData1 = data.records || [];
        if (this.gridData1 && this.gridData1.length > 0) {
          this.planYear = this.gridData1[0].year;
          this.admissionYear = this.gridData1[0].admissionYear;
        }
        let dataparams = [];
        if (this.chooseschool.length >= 0) {
          this.chooseschool.forEach((item1) => {
            this.gridData1.forEach((item) => {
              if (
                item1.collegeName === item.collegeName &&
                item1.specialtyOptions === item.specialtyOptions
              ) {
                dataparams.push(item);
              }
            });
          });
        }
        this.toggleSelection(dataparams, "myTable");
        this.dialogTableVisible1 = true;
      });
    },
    //获取专业组
    async pageoptions() {
      let res = {};
      if (this.istype === 1) {
        res = await selectCollegeList(this.formInlinezyz);
      }
      if (this.istype === 0) {
        res = await selectCollegeOptionsList(this.formInlinezyz);
      }
      let data = res.data || {};
      this.totalzyz = data.total || 0;
      this.gridDatazyz = data.records || [];
      if (this.gridDatazyz && this.gridDatazyz.length > 0) {
        this.planYear = this.gridDatazyz[0].year;
        this.admissionYear = this.gridDatazyz[0].admissionYear;
      }
      let dataparams = [];
      if (this.chooseoptions.length >= 0) {
        this.chooseoptions.forEach((item1) => {
          this.gridDatazyz.forEach((item) => {
            if (
              item1.collegeName === item.collegeName &&
              item1.specialtyOptions === item.specialtyOptions
            ) {
              dataparams.push(item);
            }
          });
        });
      }
      this.toggleSelection(dataparams, "optionsTable");
      // this.dialogTableVisiblezyz = true;
    },
    // 获取省份
    getProvinceList() {
      getProvinceList({}).then((res) => {
        if (res.code === 1) {
          this.options1 = res.data || [];
        }
      });
    },
    //获取学生详情
    getStudentDetail(id) {
      getStudentDetail({ studentId: id }).then((res) => {
        this.userform = res.data || {};
        this.formInline.disciplineType = this.userform.disciplineType;
        this.formInlinezy.disciplineType = this.userform.disciplineType;
        this.formInlinezyz.disciplineType = this.userform.disciplineType;
        if (this.userform.disciplineType === 1) {
          this.formInline.disciplines = ["物理", "化学", "生物"];
          this.formInlinezy.disciplines = ["物理", "化学", "生物"];
          this.formInlinezyz.disciplines = ["物理", "化学", "生物"];
        }
        if (this.userform.disciplineType === 2) {
          this.formInline.disciplines = ["历史", "地理", "政治"];
          this.formInlinezy.disciplines = ["历史", "地理", "政治"];
          this.formInlinezyz.disciplines = ["历史", "地理", "政治"];
        }
        if (
          this.userform.disciplineType === 0 ||
          this.userform.disciplineType === 3 ||
          this.userform.disciplineType === 4
        ) {
          this.formInline.disciplines =
            this.userform.discipline.split(",") || [];
          this.formInlinezy.disciplines =
            this.userform.discipline.split(",") || [];
          this.formInlinezyz.disciplines =
            this.userform.discipline.split(",") || [];
        }
        this.formInline.score = this.userform.adminScore;
        this.formInlinezyz.score = this.userform.adminScore;
        this.formInline.year = this.userform.graduateYear;
        this.formInlinezyz.year = this.userform.graduateYear;
        this.formInlinezy.year = this.userform.graduateYear;
        this.formInline.provinceId = this.userform.province;
        this.formInlinezy.provinceId = this.userform.province;
        this.formInlinezyz.provinceId = this.userform.province;
        if (!this.userform.scores) {
          this.userform.scores = { accumulate: null };
        }
        if (this.userform.scores) {
          this.formInline.accumulate = this.userform.scores.accumulate;
          this.formInlinezy.accumulate = this.userform.scores.accumulate;
          this.formInlinezyz.accumulate = this.userform.scores.accumulate;
        }
        this.getProvincePage();
        this.selectEqualScore();
      });
    },
    //获取方案记录
    getDraftList(idOne) {
      getDraftList({ oneId: idOne }).then((res) => {
        if (res.code === 1) {
          this.options = res.data || [];
          this.value = this.draftId;
          this.getTemplatePlanDetail(this.value);
        }
      });
    },
    //获取批次
    getProvincePage() {
      getProvincePage({
        year: this.userform.graduateYear,
        areaProvinceId: this.userform.province,
      }).then((res) => {
        let data = res.data || {};
        let records = data.records || [];
        if (records.length > 0) {
          this.batchs = records[0].batchs || [];

          this.batchs.forEach((item) => {
            if (item.batch === this.batch) {
              this.currentBatch = { ...item };
              this.$refs.volunteerTable.refreshData(
                this.currentBatch.collegeList
              );
            }
          });

          if (this.batchs.length > 0) {
            this.activeName = this.batch; //this.batchs[0].batch;
            this.formInline.admitBatch = this.batch; //this.batchs[0].batch;
            this.formInlinezy.admitBatch = this.batch; //this.batchs[0].batch;
            this.formInlinezyz.admitBatch = this.batch; //this.batchs[0].batch;
            // this.voPa = this.batchs[0].voPa || null;
          }
        }
        if (this.draftId) {
          // this.getDraftList(this.idOne);
          this.getTemplatePlanDetail(this.draftId);
        } else {
          this.getyear();
        }
      });
    },
    // 评审
    systemAssess() {
      // 预录取
      previewAdmitDraft({ draftId: this.draftId }).then((res) => {
        if (res.code === 1) {
          this.$message({
            message: "设置预录取成功",
            type: "success",
          });
        }
      });
      systemAssess({ draftId: this.draftId }).then((res) => {
        if (res.code === 1) {
          this.$message({
            message: "评审完成",
            type: "success",
          });
        }
      });
    },
    // 切换草稿
    changedraft(val) {
      console.log(val);
      this.getTemplatePlanDetail(val);
    },
    // 获取草稿志愿详情回显
    getTemplatePlanDetail(id) {
      getTemplatePlanDetail({ draftId: id }).then((res) => {
        if (res.code === 1) {
          this.data = res.data || {};
          this.templateInfo = this.data;
          this.batchs = this.data.batchs || [];

          this.batchs.forEach((item) => {
            if (item.batch === this.batch) {
              this.voPa = item.voPa;
              this.draftCollegeList = item.collegeList || [];
              this.batch = this.data.admitBatch;
              this.activeName = this.batch; //this.batchs[0].batch;
              this.formInline.admitBatch = this.batch; //this.batchs[0].batch;
              this.formInlinezy.admitBatch = this.batch; //this.batchs[0].batch;
              this.formInlinezyz.admitBatch = this.batch; //this.batchs[0].batch;
              if (item.collegeList && item.collegeList.length > 0) {
                this.year = item.collegeList[0].year || this.year;
                this.admissionYear =
                  item.collegeList[0].admissionYear || this.admissionYear;
              }

              this.currentBatch = { ...item };
              this.$refs.volunteerTable.refreshData(
                this.currentBatch.collegeList
              );
            }
          });
          // this.voPa = 1;
        }
      });
    },
    // 获取年份
    getyear() {
      let date = new Date();
      let nowtime = date.getTime();
      this.nowyear = date.getFullYear();
      this.planYear = date.getFullYear();
      this.admissionYear = this.planYear - 1;
      if (!this.draftId) {
        this.year = date.getFullYear();
        let date1 = new Date(this.year + "-09-01");
        let time = date1.getTime();
        if (nowtime < time) {
          this.year = this.year - 1;
        }
      }
    },
    //tabs批次切换
    // handleClick(tab, event) {
    //   console.log(tab, "tab");
    //   this.activeName = tab.label;
    //   this.formInline.admitBatch = tab.label;
    //   this.formInlinezy.admitBatch = tab.label;
    //   this.formInlinezyz.admitBatch = tab.label;
    //   this.batchs.forEach((item) => {
    //     if (item.batch === tab.label) {
    //       this.voPa = item.voPa || null;
    //     }
    //   });
    // },
  },
};
</script>

<style lang="less" scoped>
.box {
  padding: 20px;

  .top {
    padding: 0px 10px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 14px;
    margin-bottom: 10px;

    span {
      margin-right: 10px;
      display: inline-block;
    }
  }

  /deep/ .el-dialog-div {
    overflow: auto !important;
  }

  .button {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
}
</style>
